import GIF from "gif.js";
import SuperGif from "libgif";
import JSZip, { forEach } from "jszip";
import imageCompression from "browser-image-compression";

let qualifiedArea = document.querySelector(".li-qualified");
let notQualifiedArea = document.querySelector(".li-not-qualified");
let exitLogoArea = document.querySelector(".exit-logo-area");
let downAllArea = document.querySelector(".download-all-error-area");
let downloadExcelArea = document.querySelector(".download-all-error-area"); //excel顯示

let downloadAllErrorExcelBtn = document.querySelector(
    ".download-all-error-csv-btn"
);

let showListBodyContainer = document.querySelector(".show-list-body-container");
let uploadInput = document.querySelector("#upload-file");
let loadingContainer = document.querySelector(".loading-container");
let loadingInfoContainer = document.querySelector(".loading-info-container");
let loadingInfoContainerOfP = loadingInfoContainer.querySelector("p");
let nowIndex = 0;
let allItemObj = [];
let files;
let imgFiles = [];
let selectType = "inside";
let allFile = [];
let groupList = [];
let now = 0;

// 切換合格/不合格
let isQualified = true;

qualifiedArea.addEventListener("click", () => checkQualified(true));
notQualifiedArea.addEventListener("click", () => checkQualified(false));
qualifiedArea.addEventListener("click", needCheck);
notQualifiedArea.addEventListener("click", needCheck);
qualifiedArea.addEventListener("click", () =>
    qualifiedClick(notQualifiedArea, qualifiedArea)
);
notQualifiedArea.addEventListener("click", () =>
    qualifiedClick(qualifiedArea, notQualifiedArea)
);

function needCheck(e) {
    if (e.target.classList.contains("need-check")) {
        e.target.classList.remove("need-check");
    }
}

function checkQualified(isQualified) {
    let allListItem = document.querySelectorAll(".show-list-item");
    if (isQualified) {
        allListItem.forEach((item) => {
            if (item.dataset.qualified === "false") {
                item.style.display = "none";
            } else {
                item.style.display = "";
            }
        });
    } else {
        allListItem.forEach((item) => {
            if (item.dataset.qualified === "true") {
                item.style.display = "none";
            } else {
                item.style.display = "";
            }
        });
    }
}

function qualifiedClick(item, selfItem) {
    let notFindListArea = document.querySelector(".not-find-area");
    if (item.classList.contains("active")) {
        item.classList.remove("active");
    }
    selfItem.classList.add("active");
    if (selfItem.classList.contains("li-qualified")) {
        exitLogoArea.style.display = "";
        downloadExcelArea.style.display = "none"; //切換excel按鈕顯示

        if (notFindListArea) {
            notFindListArea.style.display = "none";
        }
    } else if (selfItem.classList.contains("li-not-qualified")) {
        exitLogoArea.style.display = "none";
        downloadExcelArea.style.display = "block"; //切換excel按鈕顯示
        if (notFindListArea) {
            notFindListArea.style.display = "";
        }
    }
}
checkQualified(isQualified);

// 檢查版位類型

let checkTypeContainer = document.querySelector(".check-type-container");
checkTypeContainer.addEventListener("change", function (e) {
    if (e.target.name === "board-is-template") {
        selectType = e.target.value;
    }
});

// 新增檔案
let addFileInput = document.querySelector("#upload-file");
addFileInput.addEventListener("input", function (e) {
    files = e.target.files; //捕獲對象的FileList
    allFile = allFile.concat(Array.from(files));
    handleFiles(files);
});

// 拖放

let dropArea = document.querySelector(".upload-area");

dropArea.addEventListener("dragenter", dragenter, false);
dropArea.addEventListener("dragover", dragover, false);
dropArea.addEventListener("drop", drop, false);
dropArea.addEventListener("click", function () {
    uploadInput.click();
});

function dragenter(e) {
    e.stopPropagation();
    e.preventDefault();
}

function dragover(e) {
    e.stopPropagation();
    e.preventDefault();
}

function drop(e) {
    e.stopPropagation();
    e.preventDefault();

    let dt = e.dataTransfer; //用來捕獲數據
    files = dt.files; //捕獲對象的FileList
    allFile = allFile.concat(Array.from(files));
    handleFiles(files);
}

function handleFiles(files) {
    loadingContainer.style.display = "block";
    loadingInfoContainerOfP.textContent = "資料處理中，請稍後...";
    let totalFiles = files.length;
    let promises = [];
    for (let i = 0; i < totalFiles; i++) {
        let file = files[i];
        let imageType = /\.(png|jpe?g|gif|mp4)$/i;

        if (!file.name.match(imageType)) {
            alert("檔案必須為PNG/JPG/GIF/MP4");
            continue;
        }

        let fileExtension = file.name.split(".").pop().toLowerCase();

        let promise;

        if (fileExtension === "mp4") {
            promise = new Promise((resolve, reject) => {
                let video = document.createElement("video");
                video.preload = "metadata";

                video.onloadedmetadata = function () {
                    window.URL.revokeObjectURL(video.src);
                    resolve({
                        index: nowIndex,
                        name: file.name,
                        size: file.size,
                        type: "mp4",
                        width: video.videoWidth,
                        height: video.videoHeight,
                        duration: video.duration,
                    });
                };

                video.onerror = function () {
                    reject("影片無法載入或格式錯誤");
                };

                video.src = URL.createObjectURL(file);
            });
        } else {
            // 原本圖片處理
            promise = new Promise((resolve, reject) => {
                let imgObj = {
                    index: nowIndex,
                    name: file.name,
                    size: file.size,
                    type: fileExtension,
                    width: 0,
                    height: 0,
                };
                const reader = new FileReader();
                reader.onload = function (e) {
                    const img = new Image();
                    img.onload = function () {
                        imgObj.width = img.width;
                        imgObj.height = img.height;
                        resolve(imgObj);
                    };
                    img.src = e.target.result;
                };
                reader.onerror = function (e) {
                    reject(e.target.error);
                };
                reader.readAsDataURL(file);
            });
        }

        makeList(i, file);
        promises.push(promise);
        nowIndex++;
    }

    Promise.all(promises)
        .then((results) => {
            imgFiles = imgFiles.concat(results);
            loadingContainer.style.display = "";
            loadingInfoContainerOfP.textContent = "";
            startCheckBtn.disabled = false;
        })
        .catch((error) => {
            console.error("Error processing files:", error);
        });
}
let startCheckBtn = document.querySelector(".start-check-btn");
startCheckBtn.disabled = true;
startCheckBtn.addEventListener("click", function () {
    allItemObj = [];
    startCheckBtn.disabled = true;
    if (notQualifiedArea.classList.contains("need-check")) {
        notQualifiedArea.classList.remove("need-check");
    }
    doFetch();
});
// 清單部分
function makeList(id, file) {
    let uploadList = document.querySelector("ol.upload-list");
    let li = document.createElement("li");
    li.className = "upload-file-name";
    let fileName = file.name;
    li.textContent = fileName;
    uploadList.append(li);
}

function doFetch() {
    loadingContainer.style.display = "block";
    loadingInfoContainerOfP.textContent = "資料處理中，請稍後...";
    const uploadData = imgFiles.map((imgObj) => {
        let fileType = imgObj.type;
        if (fileType === "jpeg") {
            fileType = "jpg";
        }
        return {
            name: imgObj.name,
            size: (imgObj.size / 1024).toFixed(2),
            type: fileType,
            width: imgObj.width,
            height: imgObj.height,
            group: selectType,
        };
    });
    console.log(uploadData);

    fetch("/filter", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": document
                .querySelector('meta[name="csrf-token"]')
                .getAttribute("content"),
        },
        body: JSON.stringify(uploadData),
    })
        .then((response) => response.json())
        .then((data) => {
            groupList = data.allBoards;
            updateUI(data.results);
            startCheckBtn.disabled = false;
            loadingContainer.style.display = "";
            loadingInfoContainerOfP.textContent = "搜尋完畢！";

            let closeAllCover = document.querySelector("#exit-all-cover");
            let closeAllLogo = document.querySelector("#exit-all-logo");

            // 預設cover不打勾，logo打勾

            if (closeAllCover.checked === true) {
                closeAllCover.checked = false;
            }
            if (closeAllLogo.checked === false) {
                closeAllLogo.checked = true;
            }
        })
        .catch((error) => console.error("Error:", error));
}

let fileNum = 0;

function updateUI(data) {
    let allOldItem = showListBodyContainer.querySelectorAll(".show-list-item");
    allOldItem.forEach((i) => {
        i.remove();
    });
    data.forEach((item, index) => {
        let fileName = item.name;
        let qualified = item.qualified;
        let falseType = item.falseType;
        let file = allFile[index];
        let dbInfo = item.matchDetail || false;
        let dbInfoQuantity = dbInfo.length || 0;
        now = index;

        if (file.name === fileName) {
            let imageType = /\.(png|jpe?g|gif|mp4)$/i;
            let fileType = file.name.match(imageType)[1];
            let final = makeItem(
                now,
                qualified,
                falseType,
                file,
                fileType,
                fileName,
                dbInfo,
                dbInfoQuantity
            );
            if (final) {
                showListBodyContainer.append(final);
            }
            makeNotFindList();
            checkQualified(true);
            qualifiedClick(notQualifiedArea, qualifiedArea);
        } else {
            return;
        }
    });
    checkQualified(true);
    qualifiedClick(notQualifiedArea, qualifiedArea);
}
// 搭配ID服用
function makeItem(
    id,
    isQualified,
    falseType,
    imgFile,
    fileType,
    fileName,
    dbInfo,
    dbInfoQuantity,
    isExpiration = false,
    originalWidth = false,
    originalHeight = false
) {
    let thisDbInfo = {};
    let dbBase;

    let isGif = fileType.toLowerCase() === "gif";
    let isMp4 = fileType.toLowerCase() === "mp4";

    // 先檢查 MP4 時長
    if (isMp4) {
        console.log("開始檢查 MP4 時長...");

        const video = document.createElement("video");
        video.src = URL.createObjectURL(imgFile);

        video.onloadedmetadata = function () {
            const duration = Math.floor(video.duration * 100) / 100;
            if (!Array.isArray(falseType)) {
                falseType = falseType ? [falseType] : [];
            }
            if (isExpiration && duration > 6.009) {
                isQualified = false;
                if (!falseType.includes("over-6-seconds")) {
                    falseType.push("over-6-seconds");
                }
            }
            if (imgFile.size > 20480 * 1024) {
                isQualified = false;
                if (!falseType.includes("video-over-size")) {
                    falseType.push("video-over-size");
                }
            }
            console.log('falseType:', falseType);
            // 立即更新 UI
            let showListItem = document.querySelector(`.show-list-item[data-item='${id}']`);
            if (showListItem) {
                showListItem.setAttribute("data-qualified", `${isQualified}`);
                showListItem.setAttribute("data-false-type", falseType.join(","));
                let info = showListItem.querySelector(".show-list-false-info");
                if (info) {
                    info.innerHTML = ""; // 先清空
                    if (!Array.isArray(falseType)) {
                        falseType = falseType ? [falseType] : [];
                    }
                    if (falseType.includes("over-6-seconds")) {
                        let p = document.createElement("p");
                        p.textContent = `影片總長度不可超過6秒！`;
                        info.append(p);
                    }
                    if (falseType.includes("video-over-size") || falseType.includes("img-over-size")) {
                        let sizeLimit = 20480;
                        if (dbInfo && dbInfo[0] && dbInfo[0].board_bg_width_size) {
                            sizeLimit = dbInfo[0].board_bg_width_size;
                        }
                        let showListFalseInfoP = document.createElement("p");
                        showListFalseInfoP.textContent = `檔案需在${sizeLimit}kb以內`;
                        info.append(showListFalseInfoP);

                        showListFalseInfoP = document.createElement("p");
                        showListFalseInfoP.textContent = `您上傳的影片檔案大小為：${(imgFile.size / 1024).toFixed(2)}kb`;
                        info.append(showListFalseInfoP);
                    }
                }
            }
            if (!showListBodyContainer.contains(showListItem)) {
                showListBodyContainer.appendChild(showListItem);
            }
            if (notQualifiedArea) {
                notQualifiedArea.classList.add("need-check");
            }
            checkQualified(true);
            qualifiedClick(notQualifiedArea, qualifiedArea);
        };
    }

    console.log("測試1");

    let showListItem = document.createElement("div");
    showListItem.classList.add("show-list-item");
    showListItem.setAttribute("data-qualified", `${isQualified}`);
    showListItem.setAttribute("data-false-type", `${falseType ?? ""}`);
    if (fileType === "jpeg") {
        fileType = "jpg";
    }
    showListItem.setAttribute("data-type", `${fileType ?? ""}`);
    showListItem.setAttribute("data-item", `${id}`);
    if (dbInfoQuantity === 1) {
        thisDbInfo.boardName = dbInfo[0].board_name;
        // 從 dbInfo 中獲取 board_bg_expiration 的值
        isExpiration = dbInfo[0].board_bg_expiration || false;
        console.log("從 dbInfo 獲取的 isExpiration:", isExpiration);

        console.log("檔案大小限制:", thisDbInfo.sizeLimit, "kb");
    } else if (dbInfoQuantity >= 1) {
        thisDbInfo.boardName = "找到複數版位";
    }
    showListItem.setAttribute("data-board-name", thisDbInfo.boardName);

    let itemObj = {
        id: id,
        imgUrl: null,
        coverUrl: null,
        logoUrl: null,
        imgLoaded: null,
        coverImgLoaded: null,
        logoImgLoaded: null,
        loadedImg: "",
        loadedCover: "",
        loadedLogo: "",
        scale: 0,
        x: 0,
        y: 0,
        imgWidth: 0,
        imgHeight: 0,
        isCoverOpen: true,
        nowPosition: {
            x: 0,
            y: 0,
        },
        isLogoOpen: false,
        logo: "",
        gif: "",
        frames: "",
        frameDelays: "",
        previousFrameData: "",
        lastRenderTime: 0,
        animationFrameId: null,
        totalDuration: 0,
        gifExpiration: 0,
        sizeLimit: 0,
        imgFile: imgFile,
    };

    itemObj.type = fileType;

    let showListItemImgArea = document.createElement("div");
    showListItemImgArea.className = "show-list-item-img-area";

    let itemCanvas;
    let videoElement;
    if (fileType === "mp4") {
        videoElement = document.createElement("video");
        videoElement.controls = true;
        videoElement.width = 500;
        videoElement.src = URL.createObjectURL(imgFile);
        videoElement.setAttribute("data-img-type", "mp4");
        videoElement.id = `video-${id}`;
        showListItemImgArea.append(videoElement);
    } else {
        itemCanvas = document.createElement("canvas");
        itemCanvas.setAttribute("data-img-type", fileType);
        itemCanvas.id = `canvas-${id}`;
        showListItemImgArea.append(itemCanvas);

        if (itemCanvas.getContext) {
            drawImagesOnCanvas(itemCanvas, itemObj, isGif);
        }
    }

    let showListItemChooseArea = document.createElement("div");
    showListItemChooseArea.className = "show-list-item-choose-area";

    // 版型名稱，都要
    let showListInfo = document.createElement("div");
    showListInfo.className = "show-list-info";
    let showListInfoP = document.createElement("p");
    showListInfoP.textContent = `版型：${thisDbInfo.boardName}`;
    showListInfo.append(showListInfoP);
    showListItemChooseArea.append(showListInfo);

    // 提示上傳圖片，有錯就要
    let showListImgInfo = document.createElement("div");
    showListImgInfo.className = "show-list-img-info";
    let showListImgInfoP = document.createElement("p");
    showListImgInfoP.textContent = `您上傳之圖片為：${fileName}`;
    showListImgInfo.append(showListImgInfoP);

    // 如果是影片，顯示影片時間
    if (fileType.toLowerCase() === "mp4") {
        const video = document.createElement("video");
        video.preload = "metadata";
        video.src = URL.createObjectURL(imgFile);
        video.onloadedmetadata = function () {
            const duration = Math.floor(video.duration * 100) / 100;
            let durationP = document.createElement("p");
            durationP.textContent = `影片長度為: ${duration} 秒`;
            showListImgInfo.append(durationP);

            // console.log("影片長度");
        };
    }
    let showListImgInfoSizeP = document.createElement("p");
    if (imgFiles[id]) {
        if (imgFiles[id].width && imgFiles[id].height)
            showListImgInfoSizeP.textContent = `您上傳的圖片尺寸為：${imgFiles[id].width}x${imgFiles[id].height}px`;
    } else if (originalWidth > 0 && originalHeight > 0) {
        showListImgInfoSizeP.textContent = `您上傳的圖片尺寸為：${originalWidth}x${originalHeight}px`;
    }
    showListImgInfo.append(showListImgInfoSizeP);
    showListItemChooseArea.append(showListImgInfo);

    // 添加錯誤訊息區域
    let showListFalseInfo = document.createElement("div");
    showListFalseInfo.className = "show-list-false-info";

    // 檢查各種錯誤情況

    console.log(falseType);

    if (falseType === "over-6-seconds") {
        console.log("影片總長度不可超過6秒！");
        let showListFalseInfoP = document.createElement("p");
        showListFalseInfoP.textContent = "影片總長度不可超過6秒！";
        showListFalseInfo.append(showListFalseInfoP);
    } else if (falseType === "invalid-format") {
        // let showListFalseInfoP = document.createElement("p");
        // showListFalseInfoP.textContent = `檔案格式需為${thisDbInfo.boardFormat}！`;
        // showListFalseInfo.append(showListFalseInfoP);
    } else if (falseType === "img-over-size") {
        // 使用第一個版位的檔案大小限制
        let sizeLimit = dbInfo[0].board_bg_width_size || 0;
        let showListFalseInfoP = document.createElement("p");
        showListFalseInfoP.textContent = `檔案需在${sizeLimit}kb以內`;
        showListFalseInfo.append(showListFalseInfoP);

        showListFalseInfoP = document.createElement("p");
        showListFalseInfoP.textContent = `您上傳的圖片檔案大小為：${(
            imgFile.size / 1024
        ).toFixed(2)}kb`;
        showListFalseInfo.append(showListFalseInfoP);
    } else if (falseType === "video-over-size") {
        console.log("顯示 MP4 檔案大小錯誤訊息");
        let showListFalseInfoP = document.createElement("p");
        showListFalseInfoP.textContent = `檔案需在 20480kb 以內`; // 直接使用後端定義的限制
        showListFalseInfo.append(showListFalseInfoP);

        showListFalseInfoP = document.createElement("p");
        showListFalseInfoP.textContent = `您上傳的影片檔案大小為：${(
            imgFile.size / 1024
        ).toFixed(2)}kb`;
        showListFalseInfo.append(showListFalseInfoP);
    } else if (falseType === "fuzzy-search") {
        let originalName = thisDbInfo.boardName;
        // thisDbInfo.boardName = "未偵測到符合之版位！";
        let showListFalseAboutTemplateInfoP = document.createElement("p");
        showListFalseAboutTemplateInfoP.textContent = `你是指?`;
        showListFalseInfo.append(showListFalseAboutTemplateInfoP);
        let showListFalseAboutTemplateInfo1 = document.createElement("p");
        showListFalseAboutTemplateInfo1.textContent = `版位：${originalName}`;
        showListFalseInfo.append(showListFalseAboutTemplateInfo1);
        // let showListFalseInfoP = document.createElement("p");
        // showListFalseInfoP.textContent = `未偵測到完全符合的版位！但有偵測到相似尺寸之版位！`;
        // showListFalseInfo.append(showListFalseInfoP);
    }

    showListItemChooseArea.append(showListFalseInfo);

    // 添加LOGO，正確/ 錯誤：格式錯誤/gif長度超過30秒
    let showLogoCheckArea = document.createElement("div");
    showLogoCheckArea.className = "show-logo-check-area";
    // 搭配ID服用
    showLogoCheckArea.innerHTML = `
    <input type="checkbox" class="show-logo-check" name="show-logo-check-${id}" id="show-logo-check-${id}" value="1">
    <label for="show-logo-check-${id}">添加LOGO</label>
    `;
    showListItemChooseArea.append(showLogoCheckArea);

    // LOGO位置選擇，正確/錯誤：格式錯誤/gif長度超過30秒
    let showPositionArea = document.createElement("div");
    showPositionArea.className = "show-position-area";
    // 搭配ID服用
    showPositionArea.innerHTML = `
    <span>位置：</span>
    <label for="show-position">
        <select name="show-position" id="show-position-${id}">
            <option value="left-up">左上</option>
            <option value="right-up">右上</option>
            <option value="right-down" selected>右下</option>
            <option value="left-down">左下</option>
        </select>
    </label>
    `;
    showListItemChooseArea.append(showPositionArea);

    let showListItemControlArea = document.createElement("div");
    showListItemControlArea.className = "show-list-item-control-area";
    let exitBtn = document.createElement("button");
    exitBtn.type = "button";
    exitBtn.classList.add(`show-list-close-cover-btn-${id}`);
    exitBtn.classList.add(`exit-btn`);
    exitBtn.setAttribute("data-canvas-id", `canvas-${id}`);
    exitBtn.textContent = "關閉遮罩";
    showListItemControlArea.append(exitBtn);

    let checkBtn = document.createElement("button");
    checkBtn.type = "button";
    checkBtn.classList.add(`show-list-download-btn-${id}`);
    checkBtn.classList.add(`check-btn`);
    checkBtn.setAttribute("data-canvas-id", `canvas-${id}`);
    checkBtn.textContent = "下載圖片";
    showListItemControlArea.append(checkBtn);

    showListItem.append(showListItemImgArea);
    showListItem.append(showListItemChooseArea);
    showListItem.append(showListItemControlArea);

    // 0612新增start
    let originalInfo = document.createElement("div");
    originalInfo.className = "original-info";
    let originalInformationSize = document.createElement("div");
    originalInformationSize.className = "original-size-info";
    originalInformationSize.textContent = `${(imgFile.size / 1024).toFixed(
        2
    )}kb`;

    let originalInformationDimensions = document.createElement("div");
    originalInformationDimensions.className = "original-dimensions-info";
    if (imgFiles[id]) {
        if (imgFiles[id].width && imgFiles[id].height)
            originalWidth = imgFiles[id].width;
        originalHeight = imgFiles[id].height;
        originalInformationDimensions.textContent = `${imgFiles[id].width}x${imgFiles[id].height}`;
    } else if (originalWidth > 0 && originalHeight > 0) {
        originalInformationDimensions.textContent = `${originalWidth}x${originalHeight}`;
    }

    originalInfo.append(originalInformationSize);
    originalInfo.append(originalInformationDimensions);
    showListItem.append(originalInfo);
    originalInfo.style.display = "none";
    // 0612新增END

    if (dbInfoQuantity === 1) {
        dbBase = dbInfo[0];
        // GIF限制三十秒(1=true,0=false)
        thisDbInfo.gifExpiration = dbBase.board_bg_expiration || 0;
        // 寬度限制
        thisDbInfo.widthLimit = dbBase.board_bg_width_limit || 0;
        // 高度限制
        thisDbInfo.heightLimit = dbBase.board_bg_height_limit || 0;
        // 檔案大小限制
        thisDbInfo.sizeLimit = dbBase.board_bg_width_size || 0;
        itemObj.sizeLimit = dbBase.board_bg_width_size || 0;
        // 允許檔名
        thisDbInfo.boardFormat = dbBase.board_format || "png";
        // 添加LOGO
        thisDbInfo.boardIsLogo = dbBase.board_is_logo || false;
        // 添加遮罩
        thisDbInfo.boardIsTemplate = dbBase.board_is_Template || false;
        // LOGO圖片位置
        thisDbInfo.logoPath = dbBase.board_logo_path || null;
        // 版型名稱
        // 遮罩圖片位置
        thisDbInfo.templatePath = dbBase.board_template_path || null;
        // 版型群組
        thisDbInfo.boardType = dbBase.board_type || "inside";
        //最後修改日期
        thisDbInfo.updatedAt = dbBase.updated_at || null;

        // GIF限制30秒
        itemObj.gifExpiration = thisDbInfo.gifExpiration;

        // MP4限制6秒
        if (fileType.toLowerCase() === "mp4") {
            const video = document.createElement("video");
            video.src = URL.createObjectURL(imgFile);

            video.onloadedmetadata = function () {
                const duration = video.duration;
                if (itemObj.gifExpiration && duration > 6.009) {
                    if (isQualified) {
                        isQualified = false;
                        falseType = "over-6-seconds";

                        showListItem.setAttribute(
                            "data-qualified",
                            `${isQualified}`
                        );
                        showListItem.setAttribute(
                            "data-false-type",
                            `${falseType}`
                        );

                        let info = showListItem.querySelector(
                            ".show-list-false-info"
                        );
                        let p = document.createElement("p");
                        info.append(p);
                    }
                }
            };
        }

        // 格式錯誤
        let showListFalseInfo = document.createElement("div");
        showListFalseInfo.className = "show-list-false-info";
        let showListFalseAboutTemplateInfo = document.createElement("div");
        showListFalseAboutTemplateInfo.className =
            "show-list-false-about-template-info";
        if (falseType === "invalid-format") {
            let showListFalseInfoP = document.createElement("p");
            showListFalseInfoP.textContent = `檔案格式需為${thisDbInfo.boardFormat}！`;
            showListFalseInfo.append(showListFalseInfoP);
        }
        // 檔案太大
        if (falseType === "img-over-size") {
            // let showListFalseInfoP = document.createElement("p");
            // showListFalseInfoP.textContent = `檔案需在${thisDbInfo.sizeLimit}kb以內`;
            // showListFalseInfo.append(showListFalseInfoP);
            // showListFalseInfoP = document.createElement("p");
            // showListFalseInfoP.textContent = `您上傳的圖片檔案大小為：${(
            //     imgFile.size / 1024
            // ).toFixed(2)}kb`;
            // showListFalseInfo.append(showListFalseInfoP);
        }
        if (falseType === "fuzzy-search") {
            // let originalName = thisDbInfo.boardName;
            // thisDbInfo.boardName = "未偵測到符合之版位！";
            // let showListFalseAboutTemplateInfoP = document.createElement("p");
            // showListFalseAboutTemplateInfoP.textContent = `未偵測到完全符合的版位！但有偵測到相似尺寸之版位！`;
            // showListFalseAboutTemplateInfo.append(
            //     showListFalseAboutTemplateInfoP
            // );
            // let showListFalseAboutTemplateInfo1 = document.createElement("p");
            // showListFalseAboutTemplateInfo1.textContent = `相似尺寸之版位：${originalName}`;
            // showListFalseAboutTemplateInfo.append(
            //     showListFalseAboutTemplateInfo1
            // );
            // let showListFalseInfoP = document.createElement("p");
            // showListFalseInfoP.textContent = `未偵測到完全符合的版位！但有偵測到相似尺寸之版位！`;
            // showListFalseInfo.append(showListFalseInfoP);
        }
        showListItemChooseArea.append(showListFalseInfo);

        showListItemChooseArea.append(showListImgInfo);
        if (showListFalseAboutTemplateInfo) {
            showListItemChooseArea.append(showListFalseAboutTemplateInfo);
        }
    } else if (dbInfoQuantity > 1) {
        thisDbInfo.boardName = "找到複數以上符合之版位！";

        let showListFalseInfo = document.createElement("div");
        showListFalseInfo.className = "show-list-false-info";
        let showListFalseAboutTemplateInfo = document.createElement("div");
        showListFalseAboutTemplateInfo.className =
            "show-list-false-about-template-info";
        if (falseType === "multiple-matches") {
            let showListFalseInfoP = document.createElement("p");
            showListFalseInfoP.textContent = `找到複數以上符合之版位！請確認並選擇符合之版位！`;
            showListFalseInfo.append(showListFalseInfoP);
        }
        if (falseType === "img-over-size") {
            // let showListFalseInfoP = document.createElement("p");
            // showListFalseInfoP.textContent = `檔案需在${thisDbInfo.sizeLimit}kb以內`;
            // showListFalseInfo.append(showListFalseInfoP);
            // showListFalseInfoP = document.createElement("p");
            // showListFalseInfoP.textContent = `您上傳的圖片檔案大小為：${(
            //     imgFile.size / 1024
            // ).toFixed(2)}kb`;
            // showListFalseInfo.append(showListFalseInfoP);
        }
        if (falseType === "invalid-format") {
            // thisDbInfo.boardName = "檔案類型不符合，找到一個以上可能的版位";
            let showListFalseAboutTemplateInfoP = document.createElement("p");
            showListFalseAboutTemplateInfoP.textContent = `您需要的是？`;
            showListFalseAboutTemplateInfo.append(
                showListFalseAboutTemplateInfoP
            );
            dbInfo.forEach((db, index) => {
                showListFalseAboutTemplateInfoP = document.createElement("p");
                showListFalseAboutTemplateInfoP.textContent = `版位：${db.board_name}`;
                showListFalseAboutTemplateInfo.append(
                    showListFalseAboutTemplateInfoP
                );
            });
            let showListFalseInfoP = document.createElement("p");
            showListFalseInfoP.textContent = `找到複數以上符合之版位！請確認並選擇符合之版位！`;
            showListFalseInfo.append(showListFalseInfoP);
            if (showListFalseAboutTemplateInfo) {
                showListItemChooseArea.append(showListFalseAboutTemplateInfo);
            }
        }

        if (falseType === "fuzzy-search") {
            // thisDbInfo.boardName = "未偵測到符合之版位！找到一個以上可能的版位";
            // let showListFalseAboutTemplateInfoP = document.createElement("p");
            // showListFalseAboutTemplateInfoP.textContent = `你是指？`;
            // showListFalseAboutTemplateInfo.append(
            //     showListFalseAboutTemplateInfoP
            // );
            // dbInfo.forEach((db, index) => {
            //     showListFalseAboutTemplateInfoP = document.createElement("p");
            //     showListFalseAboutTemplateInfoP.textContent = `${db.board_name}：${db.board_bg_width_limit}x${db.board_bg_height_limit}px`;
            //     showListFalseAboutTemplateInfo.append(
            //         showListFalseAboutTemplateInfoP
            //     );
            // });
            // let showListFalseInfoP = document.createElement("p");
            // showListFalseInfoP.textContent = `未偵測到完全符合的版位！但有偵測到複數以上相似尺寸之版位！`;
            // showListFalseInfo.append(showListFalseInfoP);
        }

        showListItemChooseArea.append(showListFalseInfo);
        showListItemChooseArea.append(showListImgInfo);
        if (showListFalseAboutTemplateInfo) {
            showListItemChooseArea.append(showListFalseAboutTemplateInfo);
        }
        // 到時候呼叫他自己
    } else {
        if (falseType === "video-over-size") {
            thisDbInfo.boardName = "不支援 20MB 以上檔案檢查，請另外人工確認";
            showListInfoP.style.color = "red";
        } else {
            thisDbInfo.boardName = "未偵測到符合之版位！";
        }
        let showListFalseInfo = document.createElement("div");
        showListFalseInfo.className = "show-list-false-info";
        let showListFalseInfoP = document.createElement("p");
        showListFalseInfoP = document.createElement("p");
        // showListFalseInfoP.textContent = "未偵測到符合之版位";

        showListFalseInfo.append(showListFalseInfoP);
        showListItemChooseArea.append(showListFalseInfo);
    }
    // 比對到多個版型
    let showListFalseChooseTemplate = document.createElement("div");
    showListFalseChooseTemplate.className = "show-list-false-choose-template";
    if (falseType === "multiple-matches") {
        let showListFalseChooseTemplateP = document.createElement("p");
        showListFalseChooseTemplateP.textContent = `您需要的是？`;
        showListFalseChooseTemplate.append(showListFalseChooseTemplateP);
        dbInfo.forEach((item, index) => {
            // 這裡GIF超過30秒要再判斷
            let label = document.createElement("label");
            label.setAttribute("for", `false-choose-template-${id}-${index}`);
            label.innerHTML = `
                <input type="checkbox" name="false-choose-template-${id}" id="false-choose-template-${id}-${index}" value="template-${index}" data-board-name=${item.board_name} data-is-expiration=${item.board_bg_expiration}>版位：${item.board_name}`;
            showListFalseChooseTemplate.append(label);
        });
        let checkBoardsBtn = document.createElement("button");
        checkBoardsBtn.type = "button";
        checkBoardsBtn.className = "show-list-check-btn";
        checkBoardsBtn.textContent = "確認選擇";
        checkBoardsBtn.id = `show-list-check-btn-${id}`;
        showListFalseChooseTemplate.append(checkBoardsBtn);
        showListItemChooseArea.append(showListFalseChooseTemplate);
        checkBoardsBtn.addEventListener("click", function () {
            let allOption = showListFalseChooseTemplate.querySelectorAll(
                "input[type='checkbox']"
            );
            let checkBoard = [];
            allOption.forEach((option) => {
                if (option.checked) {
                    checkBoard.push(option);
                }
            });
            if (checkBoard) {
                checkBoard.forEach((board, index) => {
                    let boardValue = board.value;
                    let extractedIndex = 0;
                    let match = boardValue.match(/template-(\d+)/);
                    if (match) {
                        extractedIndex = parseInt(match[1], 10);
                    }
                    const selectedDbInfo = dbInfo.filter(
                        (item, idx) => idx === extractedIndex
                    );
                    now++;
                    let isQualified = true;
                    let falseType = "";
                    let dbInfoQuantity = 1;
                    let dataBgExpiration = board.dataset.isExpiration;
                    let nowFinal = makeItem(
                        now,
                        isQualified,
                        falseType,
                        imgFile,
                        fileType,
                        fileName,
                        selectedDbInfo,
                        dbInfoQuantity,
                        dataBgExpiration,
                        originalWidth,
                        originalHeight
                    );
                    if (nowFinal) {
                        showListBodyContainer.append(nowFinal);
                    }
                    makeNotFindList();
                    let allItem = document.querySelectorAll(".show-list-item");
                    allItem.forEach((i) => {
                        if (i.getAttribute("data-item") == id) {
                            i.style.display = "none";
                            i.classList.add("board-hidden");
                            i.setAttribute("data-qualified", "");
                        }
                    });
                    checkQualified(true);
                    qualifiedClick(notQualifiedArea, qualifiedArea);
                });
            }
        });
    }

    let downLoadBtn = showListItemControlArea.querySelector(".check-btn");
    downLoadBtn.addEventListener("click", function () {
        if (fileType === "mp4") {
            console.log("下載原始 MP4 檔");
            downloadOriginalImage(
                imgFile,
                isQualified,
                thisDbInfo.boardName,
                fileType,
                false,
                showListItem
            );
            return;
        }

        if (
            (itemObj.isCoverOpen && itemObj.loadedCover) ||
            (itemObj.isLogoOpen && itemObj.logoImgLoaded)
        ) {
            console.log("有遮罩或LOGO下載CANVAS");
            // 如果要下載canvas走這邊

            let canvasId = this.getAttribute("data-canvas-id");
            let canvas = document.getElementById(canvasId);
            let fileType = canvas.getAttribute("data-img-type").toLowerCase();
            if (
                canvas &&
                (fileType === "png" ||
                    fileType === "jpg" ||
                    fileType === "jpeg")
            ) {
                let newFilename;
                if (isQualified) {
                    if (
                        showListItem.getAttribute("data-false-type") ===
                        "zip-false"
                    ) {
                        newFilename = `${fileName}`;
                    } else {
                        newFilename = `${thisDbInfo.boardName}.${fileType}`;
                    }
                } else {
                    newFilename = `${fileName}`;
                }
                downloadCanvasImage(
                    canvas,
                    newFilename,
                    fileType,
                    itemObj,
                    isQualified,
                    imgFile,
                    showListItem
                );
            } else if (canvas && fileType.toLowerCase() === "gif") {
                // GIF的下載
                let saveName = `${thisDbInfo.boardName}.gif`;

                if (itemObj && isQualified) {
                    // 下載canvas處理的圖
                    downloadGif(canvas, saveName, itemObj, isQualified);
                } else if (itemObj && !isQualified) {
                    if (
                        (itemObj.isCoverOpen && itemObj.loadedCover) ||
                        (itemObj.isLogoOpen && itemObj.logoImgLoaded)
                    ) {
                        downloadGif(canvas, imgFile.name, itemObj, isQualified);
                    } else {
                        // 下載原圖
                        saveName = `${fileName}`;
                        downloadOriginalImage(
                            imgFile,
                            isQualified,
                            thisDbInfo.boardName,
                            fileType,
                            false,
                            showListItem
                        );
                    }
                } else {
                    console.log("下載發生錯誤");
                }
            }
        } else {
            // 如果要下載原圖走這邊
            console.log("下載原圖");
            downloadOriginalImage(
                imgFile,
                isQualified,
                thisDbInfo.boardName,
                fileType,
                false,
                showListItem
            );
        }
    });

    let closeCoverBtn = showListItemControlArea.querySelector(".exit-btn");
    closeCoverBtn.addEventListener("click", function () {
        closeCover(this, itemCanvas, itemObj, isGif);
    });

    let closeLogoBtn = showLogoCheckArea.querySelector("input.show-logo-check");
    let isLogoOpen = closeLogoBtn.checked;
    closeLogoBtn.addEventListener("change", function () {
        itemObj.isLogoOpen = this.checked;
        repaint(itemCanvas, itemObj);
    });

    // 名稱
    if (isQualified) {
        showListInfoP.textContent = `版型：${thisDbInfo.boardName}`;
        if (fileType.toLowerCase() === "mp4") {
            const video = document.createElement("video");
            video.preload = "metadata";
            video.src = URL.createObjectURL(imgFile);
            // video.onloadedmetadata = function () {
            //     showListInfoP.textContent = `版型：${
            //         thisDbInfo.boardName
            //     }（影片長度為: ${Math.floor(video.duration * 100) / 100} 秒）`;
            // };
            video.onloadedmetadata = function () {
                showListInfoP.textContent = `版型：${thisDbInfo.boardName}`;
            };
        }
    } else if (
        falseType === "img-over-size" ||
        falseType === "invalid-format"
    ) {
        if (dbInfoQuantity > 1) {
            showListInfoP.textContent = `版型：${thisDbInfo.boardName}`;
            showListInfoP.style.color = "red";
        } else {
            showListInfoP.textContent = `版型：${thisDbInfo.boardName}`;
        }
    } else if (falseType === "fuzzy-search") {
        showListInfoP.textContent = `未偵測到完全符合的版位！但有偵測到相似尺寸版位！`;
    } else {
        showListInfoP.textContent = thisDbInfo.boardName;
    }

    // 處理未找到之列表
    groupList.forEach((name, index) => {
        if (name === thisDbInfo.boardName) {
            groupList.splice(index, 1);
        }
    });

    // 處理圖片區域
    let imgUrl = imgFile
        ? URL.createObjectURL(imgFile)
        : "/img/default-img.png";
    let coverUrl = thisDbInfo.templatePath
        ? `/storage/${thisDbInfo.templatePath}`
        : null;
    let logoUrl = thisDbInfo.logoPath
        ? `/storage/${thisDbInfo.logoPath}`
        : null;

    let img, coverImg, logoImg;
    let imgLoaded, coverImgLoaded, logoImgLoaded;

    itemObj.imgUrl = imgUrl;
    itemObj.coverUrl = coverUrl;
    itemObj.logoUrl = logoUrl;
    if (fileType === "mp4") {
        // 處理 MP4 → 擷取封面圖
        imgLoaded = new Promise((resolve, reject) => {
            const video = document.createElement("video");
            video.preload = "metadata";
            video.src = imgUrl;
            video.muted = true;

            video.onloadeddata = () => {
                const tempCanvas = document.createElement("canvas");
                tempCanvas.width = video.videoWidth;
                tempCanvas.height = video.videoHeight;

                const ctx = tempCanvas.getContext("2d");
                ctx.drawImage(video, 0, 0, tempCanvas.width, tempCanvas.height);

                const coverImage = new Image();
                coverImage.onload = () => resolve(coverImage);
                coverImage.onerror = () => reject("MP4 封面擷取失敗");
                coverImage.src = tempCanvas.toDataURL("image/png");
            };

            video.onerror = () => reject("MP4 載入失敗");
        });
    }
    // 這裡也要分GIF與PNG
    else if (imgUrl && fileType !== "gif") {
        img = new Image();
        imgLoaded = loadImage(img, imgUrl).catch((e) =>
            console.error("Failed to load main image:", e)
        );
    } else if (imgUrl) {
        imgLoaded = loadGif(imgUrl).then((blob) => {
            const img = document.createElement("img");
            img.src = imgUrl;
            img.style.display = "none";
            document.body.appendChild(img); // 將 img 添加到文檔中
            itemObj.gif = new SuperGif({
                gif: img,
                auto_play: false,
            });
            return new Promise((resolve) => {
                itemObj.gif.load(() => {
                    itemObj.frames = itemObj.gif.get_frames();
                    itemObj.frameDelays = itemObj.frames.map(
                        (frame) => frame.delay
                    );
                    itemCanvas.width = itemObj.gif.get_canvas().width;
                    itemCanvas.height = itemObj.gif.get_canvas().height;

                    let totalDuration = itemObj.frameDelays.reduce(
                        (sum, delay) => sum + delay,
                        0
                    );

                    // 轉換為秒（假設延遲時間的單位是百分之一秒）
                    totalDuration = totalDuration / 100;

                    itemObj.totalDuration = totalDuration;
                    if (itemObj.gifExpiration && totalDuration > 30) {
                        if (isQualified) {
                            isQualified = false;
                            falseType = "over-30-seconds";

                            showListItem.setAttribute(
                                "data-qualified",
                                `${isQualified}`
                            );
                            showListItem.setAttribute(
                                "data-false-type",
                                `${falseType}`
                            );
                            let info = showListItem.querySelector(
                                ".show-list-false-info"
                            );
                            let p = document.createElement("p");
                            p.textContent = "gif總長度不可超過30秒！";
                            info.append(p);
                        }
                    }
                    if (isExpiration == 0) {
                        if (itemObj.gifExpiration == 0 || totalDuration <= 30) {
                        }

                        checkQualified(true);
                        qualifiedClick(notQualifiedArea, qualifiedArea);
                    }

                    if (isExpiration == 1) {
                        if (totalDuration > 30) {
                            if (isQualified) {
                                isQualified = false;
                                falseType = "over-30-seconds";
                                showListItem.setAttribute(
                                    "data-qualified",
                                    `${isQualified}`
                                );
                                showListItem.setAttribute(
                                    "data-false-type",
                                    `${falseType}`
                                );
                                showListItem.setAttribute(
                                    "data-is-expiration",
                                    true
                                );
                            }
                        }

                        checkQualified(true);
                        qualifiedClick(notQualifiedArea, qualifiedArea);
                    }

                    // uploadFile.gifLoaded = true; // 標記GIF已加載完成
                    resolve(img);
                });
            });
        });
    }
    if (coverUrl) {
        coverImg = new Image();
        coverImgLoaded = loadImage(coverImg, coverUrl).catch((e) =>
            console.error("Failed to load cover image:", e)
        );
    }
    if (logoUrl) {
        logoImg = new Image();
        logoImgLoaded = loadImage(logoImg, logoUrl).catch((e) =>
            console.error("Failed to load logo image:", e)
        );
    }

    itemObj.imgUrl = imgUrl;
    itemObj.coverUrl = coverUrl;
    itemObj.logoUrl = logoUrl;
    itemObj.imgLoaded = imgLoaded;
    itemObj.coverImgLoaded = coverImgLoaded;
    itemObj.logoImgLoaded = logoImgLoaded;

    allItemObj.push(itemObj);
    if (fileType !== "mp4") {
        drawImagesOnCanvas(itemCanvas, itemObj, isGif);
    }
    // 處理canvas的顯示

    let selectItem = showPositionArea.querySelector("select");
    selectItem.addEventListener("change", () =>
        changeLogoPosition(selectItem, itemCanvas, logoImg, itemObj, isGif)
    );
    if (!itemObj.logoImgLoaded) {
        showLogoCheckArea.style.display = "none";
        showPositionArea.style.display = "none";
    }
    if (!itemObj.coverImgLoaded) {
        exitBtn.style.display = "none";
    }

    return showListItem;
}

function drawImagesOnCanvas(itemCanvas, itemObj, isGif) {
    let ctx = itemCanvas.getContext("2d");

    Promise.all([
        itemObj.imgLoaded,
        itemObj.coverImgLoaded,
        itemObj.logoImgLoaded,
    ]).then((values) => {
        console.log("✅ Promise.all 結果：", values);

        let [loadedImg, loadedCover, loadedLogo] = values;

        let imgWidth = loadedImg.width;
        let imgHeight = loadedImg.height;
        let canvasWidth = 500;
        let canvasHeight = 360;
        let scaleWidth = canvasWidth / imgWidth;
        let scaleHeight = canvasHeight / imgHeight;
        let scale = Math.min(scaleWidth, scaleHeight);

        itemCanvas.width = imgWidth;
        itemCanvas.height = imgHeight;

        if (scale === scaleWidth) {
            itemCanvas.style.width = `${canvasWidth}px`;
        } else {
            itemCanvas.style.height = `${canvasHeight}px`;
        }

        let x = 0;
        let y = 0;

        itemObj.scale = scale;
        itemObj.x = x;
        itemObj.y = y;
        itemObj.imgWidth = imgWidth;
        itemObj.imgHeight = imgHeight;
        itemObj.loadedImg = loadedImg;
        itemObj.loadedCover = loadedCover;
        itemObj.loadedLogo = loadedLogo;

        ctx.clearRect(0, 0, canvasWidth, canvasHeight);

        // ✅ 如果是 MP4，只繪製原圖
        if (itemObj.type === "mp4") {
            ctx.drawImage(loadedImg, x, y, loadedImg.width, loadedImg.height);
            return; // 不再往下繪製遮罩或 Logo
        }

        // 非 MP4：繼續 GIF 或圖像處理
        if (!isGif) {
            if (itemObj.loadedImg) {
                ctx.drawImage(
                    loadedImg,
                    x,
                    y,
                    loadedImg.width,
                    loadedImg.height
                );
            }
        } else {
            drawFrame(itemCanvas, ctx, itemObj);
        }

        if (itemObj.loadedCover) {
            ctx.drawImage(
                loadedCover,
                x,
                y,
                loadedCover.width,
                loadedCover.height
            );
        }

        if (itemObj.loadedImg && itemObj.loadedLogo) {
            itemObj.nowPosition = {
                x: x + loadedImg.width - loadedLogo.width,
                y: y + loadedImg.height - loadedLogo.height,
            };
        }

        if (itemObj.imgLoaded) {
            URL.revokeObjectURL(itemObj.imgLoaded);
        }
    });
    // .catch((error) => {
    //     console.error("無法讀取圖像", error);
    // });
}

function loadImage(image, src) {
    return new Promise((resolve, reject) => {
        if (!src) {
            reject(new Error("No source provided"));
        } else {
            image.onload = () => resolve(image);
            image.onerror = () =>
                reject(new Error("Failed to load image " + src));
            image.src = src;
        }
    });
}

function changeLogoPosition(select, canvasObj, logoImg, itemObj, isGif) {
    let chooseDirection = select.value;
    itemObj.nowPosition = calculateLogoPosition(
        chooseDirection,
        itemObj,
        logoImg
    );

    // 重新渲染
    repaint(canvasObj, itemObj);
}

function calculateLogoPosition(chooseDirection, itemObj, logoImg) {
    let position = {
        x: 0,
        y: 0,
    };
    let logoWidth, logoHeight;
    if (logoImg) {
        logoWidth = itemObj.loadedLogo.width;
        logoHeight = itemObj.loadedLogo.height;
    }
    switch (chooseDirection) {
        case "right-up":
            position.x = itemObj.x + (itemObj.imgWidth - logoWidth);
            position.y = itemObj.y;
            break;
        case "left-up":
            position.x = itemObj.x;
            position.y = itemObj.y;
            break;
        case "right-down":
            position.x = itemObj.x + (itemObj.imgWidth - logoWidth);
            position.y = itemObj.y + (itemObj.imgHeight - logoHeight);
            break;
        case "left-down":
            position.x = itemObj.x;
            position.y = itemObj.y + (itemObj.imgHeight - logoHeight);
            break;
    }
    return position;
}

async function downloadCanvasImage(
    canvas,
    filename,
    fileType,
    itemObj,
    isQualified,
    imgFile,
    thisItem
) {
    let oldSize = 0;
    let compressionFailed = false;
    if (fileType === "jpeg") {
        fileType = "jpg";
    }

    canvas.toBlob(
        async function (blob) {
            let compressedBlob = blob;
            if (
                blob.size > itemObj.sizeLimit * 1024 &&
                itemObj.sizeLimit != 0 &&
                isQualified
            ) {
                try {
                    let quality = 0.95;
                    while (
                        compressedBlob.size > itemObj.sizeLimit * 1024 &&
                        quality > 0.1
                    ) {
                        if (
                            thisItem.getAttribute("data-false-type") ===
                            "zip-false"
                        ) {
                            break;
                        }
                        if (oldSize === compressedBlob.size) {
                            compressionFailed = true;
                            if (thisItem) {
                                if (
                                    thisItem.getAttribute("data-qualified") ===
                                    "true"
                                ) {
                                    thisItem.setAttribute(
                                        "data-qualified",
                                        "false"
                                    );
                                    if (
                                        !thisItem.getAttribute(
                                            "data-false-type"
                                        )
                                    ) {
                                        thisItem.setAttribute(
                                            "data-false-type",
                                            "zip-false"
                                        );
                                        let itemFalseInfo =
                                            thisItem.querySelector(
                                                ".show-list-false-info"
                                            );
                                        let p = document.createElement("p");
                                        p.textContent =
                                            "合格素材！但通過小幫手工具下載時壓縮失敗，請手動處理原始圖檔";
                                        if (itemFalseInfo) {
                                            itemFalseInfo.append(p);
                                        }
                                        checkQualified(true);
                                        qualifiedClick(
                                            notQualifiedArea,
                                            qualifiedArea
                                        );

                                        if (notQualifiedArea) {
                                            notQualifiedArea.classList.add(
                                                "need-check"
                                            );
                                        }
                                        alert(
                                            "圖片壓縮失敗！請前往不合格區域查看並手動處理！"
                                        );
                                        // 開始寫高亮的CSS等等...還有排序，還有ALERT...
                                    }
                                }
                            }
                            break;
                        }
                        const options = {
                            maxSizeMB: itemObj.sizeLimit / 1024, // size in MB
                            useWebWorker: true,
                            fileType:
                                fileType === "jpg" ? "image/jpeg" : "image/png",
                            initialQuality: quality,
                            alwaysKeepResolution: true,
                        };
                        compressedBlob = await imageCompression(
                            compressedBlob,
                            options
                        );

                        oldSize = compressedBlob.size;
                        quality -= 0.05; // 每次减少质量
                    }
                } catch (error) {
                    console.error("圖像壓縮失敗: " + error.message);
                    compressionFailed = true;
                }
            }
            let zipFail = true;
            if (compressionFailed) {
                downloadOriginalImage(
                    imgFile,
                    isQualified,
                    filename,
                    fileType,
                    zipFail
                );
            } else {
                downloadBlob(compressedBlob, filename);
            }
        },
        fileType === "jpg" ? "image/jpeg" : "image/png",
        fileType === "jpg" ? 1 : undefined
    );
}

function downloadBlob(blob, filename) {
    let link = document.createElement("a");
    link.download = filename;
    link.href = URL.createObjectURL(blob);
    link.click();
    URL.revokeObjectURL(link.href);
}

function downloadCanvasImageForZip(
    canvas,
    fileType,
    itemObj,
    itemId,
    thisItem
) {
    return new Promise(async (resolve, reject) => {
        if (fileType === "jpeg") {
            fileType = "jpg";
        }
        let oldSize = 0;
        let compressionFailed = false;
        let imgFile;
        if (itemId >= 0) {
            imgFile = itemObj.imgFile;
        }
        let hasOverlayOrLogo =
            (itemObj.isCoverOpen && itemObj.loadedCover) ||
            (itemObj.isLogoOpen && itemObj.logoImgLoaded);

        if (!hasOverlayOrLogo) {
            resolve({
                blob: imgFile,
                name: null,
                failed: false,
            });
            return;
        }
        canvas.toBlob(
            async function (blob) {
                let compressedBlob = blob;
                if (blob) {
                    if (
                        blob.size > itemObj.sizeLimit * 1024 &&
                        itemObj.sizeLimit != 0
                    ) {
                        try {
                            let quality = 0.95;
                            while (
                                compressedBlob.size >
                                    itemObj.sizeLimit * 1024 &&
                                quality > 0.1
                            ) {
                                if (
                                    thisItem.getAttribute("data-false-type") ===
                                    "zip-false"
                                ) {
                                    break;
                                }
                                if (oldSize === compressedBlob.size) {
                                    compressionFailed = true;
                                    if (thisItem) {
                                        if (
                                            thisItem.getAttribute(
                                                "data-qualified"
                                            ) === "true"
                                        ) {
                                            thisItem.setAttribute(
                                                "data-qualified",
                                                "false"
                                            );
                                            if (
                                                !thisItem.getAttribute(
                                                    "data-false-type"
                                                )
                                            ) {
                                                thisItem.setAttribute(
                                                    "data-false-type",
                                                    "zip-false"
                                                );
                                                let itemFalseInfo =
                                                    thisItem.querySelector(
                                                        ".show-list-false-info"
                                                    );
                                                let p =
                                                    document.createElement("p");
                                                p.textContent =
                                                    "合格素材！但通過小幫手工具下載時壓縮失敗，請手動處理原始圖檔";
                                                if (itemFalseInfo) {
                                                    itemFalseInfo.append(p);
                                                }
                                                checkQualified(true);
                                                qualifiedClick(
                                                    notQualifiedArea,
                                                    qualifiedArea
                                                );
                                            }
                                        }
                                    }
                                    break;
                                }
                                const options = {
                                    maxSizeMB: itemObj.sizeLimit / 1024, // size in MB
                                    useWebWorker: true,
                                    maxWidthOrHeight: undefined,
                                    fileType:
                                        fileType === "jpg"
                                            ? "image/jpeg"
                                            : "image/png",
                                    initialQuality: quality,
                                    alwaysKeepResolution: true,
                                };
                                compressedBlob = await imageCompression(
                                    compressedBlob,
                                    options
                                );

                                oldSize = compressedBlob.size;
                                quality -= 0.05; // 每次减少质量
                            }
                        } catch (error) {
                            reject(new Error("圖像壓縮失敗: " + error.message));
                            compressionFailed = true;
                        }
                        if (compressionFailed) {
                            resolve({
                                blob: imgFile,
                                name: `壓縮失敗需手動調整-${imgFile.name}`,
                                failed: true,
                            });
                        } else {
                            resolve({
                                blob: compressedBlob,
                                name: null,
                            });
                        }
                    } else {
                        resolve({
                            blob: blob,
                            name: null,
                        });
                    }
                } else {
                    resolve({
                        blob: imgFile,
                        name: `壓縮失敗需手動調整-${imgFile.name}`,
                        failed: true,
                    });
                }
            },
            fileType === "jpg" ? "image/jpeg" : "image/png",
            fileType === "jpg" ? 1 : undefined
        );
    });
}

let downAllImage = document.querySelector("#download-all-image");

downAllImage.addEventListener("click", downloadAllImages);
async function downloadAllImages() {
    const allItems = document.querySelectorAll(".show-list-item");
    const zip = new JSZip();
    let nameCount = {};
    let tempNameCount = {};
    let hasCompressionFailed = false;

    allItems.forEach((item) => {
        const isQualified = item.getAttribute("data-qualified") === "true";
        const itemBoardName = item.getAttribute("data-board-name");
        if (isQualified && itemBoardName !== "找到複數版位") {
            tempNameCount[itemBoardName] =
                (tempNameCount[itemBoardName] || 0) + 1;
        }
    });

    const promises = Array.from(allItems).map(async (item) => {
        const canvas = item.querySelector("canvas");

        const isQualified = item.getAttribute("data-qualified") === "true";
        const itemBoardName = item.getAttribute("data-board-name");

        // 特別情況遇到mp4的
        if (!canvas) {
            const video = item.querySelector("video");

            if (video && isQualified && itemBoardName !== "找到複數版位") {
                const videoSrc = video.getAttribute("src");
                const response = await fetch(videoSrc);
                const blob = await response.blob();

                const saveName =
                    getSaveName(itemBoardName, tempNameCount, nameCount) +
                    ".mp4";
                zip.file(saveName, blob);
            }

            return; // MP4 處理完就跳過了
        }
        // 正常情況下繼續處理
        const fileType = canvas.getAttribute("data-img-type").toLowerCase();

        if (fileType === "jpeg") {
            fileType = "jpg";
        }
        if (isQualified && itemBoardName !== "找到複數版位") {
            let saveName =
                getSaveName(itemBoardName, tempNameCount, nameCount) +
                (fileType === "gif"
                    ? ".gif"
                    : fileType === "jpg"
                    ? ".jpg"
                    : ".png");

            let itemId = canvas.id.split("-")[1];
            let itemObj;
            let thisItem;
            if (itemId) {
                itemObj = allItemObj.find((item) => item.id == itemId);
                thisItem = document.querySelector(
                    `.show-list-item[data-item="${itemId}"]`
                );
            }

            if (fileType === "gif") {
                // GIF的下載
                let hasOverlayOrLogo;
                if (itemObj) {
                    hasOverlayOrLogo =
                        (itemObj.isCoverOpen && itemObj.loadedCover) ||
                        (itemObj.isLogoOpen && itemObj.logoImgLoaded);
                }

                if (!hasOverlayOrLogo) {
                    // 没有遮罩或LOGO，直接下載原圖
                    // 如果這邊我使用imgFiles[id]，可能會造成makeItem的問題因為他沒有imgFiles[id]
                    if (itemObj.imgFile) {
                        const blob = itemObj.imgFile;
                        zip.file(saveName, blob);
                    } else {
                        console.log("找不到GIF圖片");
                    }
                } else {
                    const blob = await downloadGifZip(
                        canvas,
                        saveName,
                        itemObj
                    );
                    const compressedBlob = await compressGifForZip(
                        blob,
                        128,
                        saveName,
                        itemObj
                    );
                    zip.file(saveName, compressedBlob);
                }
            } else {
                const { blob, name, failed } = await downloadCanvasImageForZip(
                    canvas,
                    fileType,
                    itemObj,
                    itemId,
                    thisItem
                );
                if (name) {
                    saveName = name;
                }
                if (failed) {
                    hasCompressionFailed = true; //壓縮失敗
                }
                zip.file(saveName, blob);
            }
        }
    });
    await Promise.all(promises);

    zip.generateAsync({
        type: "blob",
    }).then((blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "downloaded_images.zip";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        if (hasCompressionFailed) {
            if (notQualifiedArea) {
                notQualifiedArea.classList.add("need-check");
            }
            alert("部分圖片壓縮失敗！請前往不合格區域查看並手動處理！");
        }
    });
}

function getSaveName(boardName, tempNameCount, nameCount) {
    nameCount[boardName] = (nameCount[boardName] || 0) + 1;
    let saveName = `${boardName}`;
    if (tempNameCount[boardName] > 1) {
        saveName += `-${nameCount[boardName]}`;
    }
    return saveName;
}

let closeAllCover = document.querySelector("#exit-all-cover");
closeAllCover.addEventListener("change", function (e) {
    allItemObj.forEach((item, index) => {
        if (this.checked) {
            item.isCoverOpen = true;
        } else {
            item.isCoverOpen = false;
        }
        let button = document.querySelector(
            `.exit-btn[data-canvas-id='canvas-${item.id}']`
        );
        let canvas = document.querySelector(`canvas[id='canvas-${item.id}']`);
        closeCover(button, canvas, item);
    });
});

// 關閉遮罩區域
function closeCover(button, canvas, itemObj, isGif = false) {
    if (itemObj.isCoverOpen) {
        button.textContent = "開啟遮罩";
        itemObj.isCoverOpen = false;
    } else {
        button.textContent = "關閉遮罩";
        itemObj.isCoverOpen = true;
    }
    repaint(canvas, itemObj);
}

// 關閉LOGO

let closeAllLogo = document.querySelector("#exit-all-logo");
closeAllLogo.addEventListener("change", function (e) {
    allItemObj.forEach((item, index) => {
        if (this.checked) {
            item.isLogoOpen = true;
        } else {
            item.isLogoOpen = false;
        }
        let canvas = document.querySelector(`canvas[id='canvas-${item.id}']`);
        item.isLogoOpen = !this.checked;
        let logoInput = document.querySelector(
            `input#show-logo-check-${item.id}`
        );
        logoInput.checked = !this.checked;
        repaint(canvas, item);
    });
});

// 切換所有LOGO位置
let changeAllPosition = document.querySelector("#change-all-position");
changeAllPosition.addEventListener("change", function () {
    let allCanvas = document.querySelectorAll(".show-list-item canvas");
    let allItem = document.querySelectorAll(".show-list-item");
    allItemObj.forEach((item, index) => {
        if (item.loadedLogo) {
            item.nowPosition = calculateLogoPosition(
                changeAllPosition.value,
                item,
                item.loadedLogo
            );
            if (allItem[index]) {
                let canvas = allItem[index].querySelector("canvas");
                let select = allItem[index].querySelector("select");
                if (select) {
                    select.value = changeAllPosition.value;
                }
                if (canvas) {
                    repaint(canvas, item);
                }
            }
        }
    });
});

// 重新繪製
function repaint(canvas, itemObj, isGif = false) {
    // 其實就是mp4因為沒有canvas所以這邊要跳過
    if (!canvas) {
        console.warn("canvas 為 null，跳過 repaint", itemObj);
        return;
    }

    let logoWidth, logoHeight;

    if (itemObj.loadedLogo) {
        logoWidth = itemObj.loadedLogo.width;
        logoHeight = itemObj.loadedLogo.height;
    }
    let ctx = canvas.getContext("2d");
    // 這邊是mp4的時候沒有ctx所以這邊要跳過
    if (!ctx) {
        console.warn("無法取得 canvas context，跳過", canvas);
        return;
    }

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    if (isGif) {
        // GIF的時候，畫布
        drawFrame(itemCanvas, ctx, itemObj);
    } else {
        if (itemObj.loadedImg) {
            ctx.drawImage(
                itemObj.loadedImg,
                itemObj.x,
                itemObj.y,
                itemObj.loadedImg.width,
                itemObj.loadedImg.height
            );
        }
        if (itemObj.isCoverOpen && itemObj.loadedCover) {
            ctx.drawImage(
                itemObj.loadedCover,
                itemObj.x,
                itemObj.y,
                itemObj.loadedCover.width,
                itemObj.loadedCover.height
            );
        }
        if (itemObj.isLogoOpen && itemObj.logoImgLoaded) {
            ctx.drawImage(
                itemObj.loadedLogo,
                itemObj.nowPosition.x,
                itemObj.nowPosition.y,
                logoWidth,
                logoHeight
            );
        }
    }
}

function makeNotFindList() {
    let ul = showListBodyContainer.querySelector("ul.not-find-list");
    if (ul) {
        ul.innerHTML = "";
    } else {
        let div = document.createElement("div");
        div.className = "not-find-area";
        ul = document.createElement("ul");
        ul.className = "not-find-list";
        let h3 = document.createElement("h3");
        h3.textContent = "缺少版位列表";
        div.append(h3);
        div.append(ul);
        showListBodyContainer.append(div);
    }
    groupList.forEach((liText, index) => {
        let li = document.createElement("li");
        li.textContent = `${index + 1} . ${liText}`;
        ul.append(li);
    });
}

function drawFrame(canvas, ctx, itemObj) {
    let logo = itemObj.logo;
    let gif = itemObj.gif;
    let frames = itemObj.frames;
    let frameDelays = itemObj.frameDelays;
    let previousFrameData = itemObj.previousFrameData;
    let lastRenderTime = itemObj.lastRenderTime;
    let animationFrameId = itemObj.animationFrameId;

    if (gif && frames && frameDelays) {
        let frameIndex = 0;

        function draw(timestamp) {
            if (!lastRenderTime) {
                lastRenderTime = timestamp;
            }
            let frame;
            let delay;

            if (frames) {
                frame = frames[frameIndex];
            }
            if (frameDelays) {
                delay = frameDelays[frameIndex] * 10;
            }

            if (timestamp - lastRenderTime >= delay) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                gif.move_to(frameIndex);
                ctx.drawImage(gif.get_canvas(), 0, 0);

                let coverImg;
                if (itemObj.loadedCover && itemObj.loadedCover.complete) {
                    coverImg = itemObj.loadedCover;
                    drawCover(itemObj, coverImg, canvas, ctx);
                }

                let logoImg;
                if (itemObj.loadedLogo && itemObj.loadedLogo.complete) {
                    logoImg = itemObj.loadedLogo;
                    drawLogo(itemObj, logoImg, canvas, ctx);
                }

                frameIndex = (frameIndex + 1) % frames.length;
                lastRenderTime = timestamp;
            }

            requestAnimationFrame(draw);
        }

        requestAnimationFrame(draw);
    }
}

function drawLogo(itemObj, logoImg, canvas, ctx) {
    let logoX = itemObj.nowPosition.x;
    let logoY = itemObj.nowPosition.y;
    if (logoImg && itemObj.isLogoOpen) {
        ctx.drawImage(logoImg, logoX, logoY, logoImg.width, logoImg.height);
    }
}

function drawCover(itemObj, coverImg, canvas, ctx) {
    if (coverImg && itemObj.isCoverOpen) {
        ctx.drawImage(coverImg, 0, 0, coverImg.width, coverImg.height);
    }
}

function loadGif(url) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "blob";
        xhr.onload = function () {
            if (this.status === 200) {
                resolve(this.response);
            } else {
                reject(new Error("GIF load failed"));
            }
        };
        xhr.send();
    });
}

function downloadGif(canvas, boardName, itemObj, isQualified) {
    let gif = itemObj.gif;
    let frames = itemObj.frames;
    let frameDelays = itemObj.frameDelays;
    if (!gif || !frames || !frameDelays) return;
    let ctx = canvas.getContext("2d");
    // 如果是有限制30秒，就要檢查repeat次數
    let repeatTimes = 0;
    if (itemObj.gifExpiration && itemObj.totalDuration) {
        let limitTime = 30; //限制在30秒內
        repeatTimes = Math.floor(limitTime / itemObj.totalDuration) - 1; //減1是因為預設會多一次
    }
    const gifEncoder = new GIF({
        workers: 2,
        quality: 30,
        workerScript: "/gif.worker.js",
        width: canvas.width,
        height: canvas.height,
        repeat: repeatTimes,
    });

    frames.forEach((frame, index) => {
        gif.move_to(index);
        ctx.drawImage(gif.get_canvas(), 0, 0);
        let coverImg;
        if (itemObj.loadedCover && itemObj.loadedCover.complete) {
            coverImg = itemObj.loadedCover;
            drawCover(itemObj, coverImg, canvas, ctx);
        }

        let logoImg;
        if (itemObj.loadedLogo && itemObj.loadedLogo.complete) {
            logoImg = itemObj.loadedLogo;
            drawLogo(itemObj, logoImg, canvas, ctx);
        }
        gifEncoder.addFrame(ctx, {
            copy: true,
            delay: frameDelays[index] * 10,
        }); // 確保延遲時間正確
    });

    gifEncoder.on("finished", function (blob) {
        cleanGif(blob)
            .then((cleanedBlob) => {
                compressGif(cleanedBlob, 128, boardName, itemObj, isQualified);
            })
            .catch((error) => {
                console.error("GIF 清理錯誤: ", error.message);
            });
    });

    gifEncoder.render();
}

function downloadGifZip(canvas, boardName, itemObj) {
    return new Promise((resolve, reject) => {
        let gif = itemObj.gif;
        let frames = itemObj.frames;
        let frameDelays = itemObj.frameDelays;
        if (!gif || !frames || !frameDelays) {
            reject(new Error("GIF 或其資料不完整"));
            return;
        }
        let ctx = canvas.getContext("2d");
        // 如果是有限制30秒，就要檢查repeat次數
        let repeatTimes = 0;
        if (itemObj.gifExpiration && itemObj.totalDuration) {
            let limitTime = 30; //限制在30秒內
            repeatTimes = Math.floor(limitTime / itemObj.totalDuration) - 1; //減1是因為預設會多一次
        }
        const gifEncoder = new GIF({
            workers: 2,
            quality: 30,
            workerScript: "/gif.worker.js",
            width: canvas.width,
            height: canvas.height,
            repeat: repeatTimes,
        });

        frames.forEach((frame, index) => {
            gif.move_to(index);
            ctx.drawImage(gif.get_canvas(), 0, 0);
            let coverImg;
            if (itemObj.loadedCover && itemObj.loadedCover.complete) {
                coverImg = itemObj.loadedCover;
                drawCover(itemObj, coverImg, canvas, ctx);
            }

            let logoImg;
            if (itemObj.loadedLogo && itemObj.loadedLogo.complete) {
                logoImg = itemObj.loadedLogo;
                drawLogo(itemObj, logoImg, canvas, ctx);
            }
            gifEncoder.addFrame(ctx, {
                copy: true,
                delay: frameDelays[index] * 10,
            });
        });

        gifEncoder.on("finished", function (blob) {
            cleanGif(blob)
                .then((cleanedBlob) => {
                    resolve(cleanedBlob);
                })
                .catch((error) => {
                    reject(error);
                });
        });

        gifEncoder.on("abort", function () {
            reject(new Error("GIF 生成被中斷"));
        });

        gifEncoder.on("error", function (error) {
            reject(new Error("GIF 生成錯誤: " + error.message));
        });

        gifEncoder.render();
    });
}

function cleanGif(blob) {
    return new Promise((resolve, reject) => {
        let fr = new FileReader();
        fr.onload = function (e) {
            let arrayBuffer = e.target.result;
            let uint8Array = new Uint8Array(arrayBuffer);

            let gifEndIndex = uint8Array.lastIndexOf(0x3b);
            if (gifEndIndex === -1) {
                reject(new Error("未找到 GIF 結尾標記"));
                return;
            }

            let cleanArrayBuffer = uint8Array.slice(0, gifEndIndex + 1).buffer;
            let cleanBlob = new Blob([cleanArrayBuffer], {
                type: "image/gif",
            });
            resolve(cleanBlob);
        };
        fr.onerror = function (error) {
            reject(new Error("讀取 GIF 檔案錯誤: " + error.message));
        };
        fr.readAsArrayBuffer(blob);
    });
}

function compressGif(blob, colors, boardName, itemObj, isQualified) {
    let fr = new FileReader();
    fr.onload = function (e) {
        let arrayBuffer = e.target.result;
        let result = gifmin(arrayBuffer, colors);
        let compressedBlob = new Blob([result], {
            type: "image/gif",
        });

        if (
            compressedBlob.size > itemObj.sizeLimit * 1024 &&
            colors > 2 &&
            isQualified
        ) {
            let newColors = Math.max(2, Math.floor(colors / 2));
            compressGif(blob, newColors, boardName, itemObj); // 重新調用壓縮函數
        } else {
            let blobUrl = window.URL.createObjectURL(compressedBlob);
            downloadFileByBlob(blobUrl, boardName);
        }
    };
    fr.readAsArrayBuffer(blob);
}

function downloadFileByBlob(blobUrl, boardName) {
    const eleLink = document.createElement("a");
    eleLink.download = boardName;
    eleLink.style.display = "none";
    eleLink.href = blobUrl;
    document.body.appendChild(eleLink);
    eleLink.click();
    document.body.removeChild(eleLink);
    window.URL.revokeObjectURL(blobUrl);
}

function compressGifForZip(blob, colors, boardName, itemObj) {
    return new Promise((resolve, reject) => {
        let fr = new FileReader();

        fr.onload = function (e) {
            let arrayBuffer = e.target.result;
            try {
                let result = gifmin(arrayBuffer, colors);
                let compressedBlob = new Blob([result], {
                    type: "image/gif",
                });

                if (
                    compressedBlob.size > itemObj.sizeLimit * 1024 &&
                    colors > 2
                ) {
                    let newColors = Math.max(2, Math.floor(colors / 2));
                    return compressGifForZip(
                        compressedBlob,
                        newColors,
                        boardName,
                        itemObj
                    )
                        .then(resolve)
                        .catch(reject);
                } else {
                    resolve(compressedBlob);
                }
            } catch (error) {
                reject(new Error("GIF 壓縮錯誤: " + error.message));
            }
        };
        fr.onerror = function (error) {
            reject(new Error("GIF 壓縮錯誤: " + error.message));
        };
        fr.readAsArrayBuffer(blob);
    });
}

function downloadOriginalImage(
    imgFile,
    isQualified,
    name,
    type,
    zipFail = false,
    thisItem = false
) {
    const reader = new FileReader();
    reader.onload = function (event) {
        let newFilename = "";
        if (isQualified) {
            if (zipFail) {
                console.log("壓縮失敗");
                newFilename = `壓縮失敗需手動調整-${imgFile.name}`;
            } else {
                if (thisItem.getAttribute("data-false-type") === "zip-false") {
                    console.log("壓縮失敗");
                    newFilename = `${imgFile.name}`;
                } else {
                    newFilename = `${name}.${type}`;
                }
            }
        } else {
            newFilename = `${imgFile.name}`;
        }
        const url = event.target.result;
        // Create a temporary link element
        const link = document.createElement("a");
        link.href = url;
        link.download = newFilename;

        // Append the link to the body
        document.body.appendChild(link);

        // Trigger the download by clicking the link
        link.click();

        // Remove the link from the document
        document.body.removeChild(link);
    };

    reader.readAsDataURL(imgFile);
}

// excel導出傳輸資料模組

// 假設 yourDataArray 是你要傳送的數據
const yourDataArray = [
    {
        column1: "Google-直立矩形廣告-240x400",
        column2: "24-0515-百虹歡璽城 (7).jpg",
        column3: `檔案需在150kb以內\n您上傳的圖片檔案大小為：219.86kb`,
    },
    {
        column1: "Google-正方形廣告-250x250",
        column2: "24-0515-百虹歡璽城 (8).jpg",
        column3: `檔案需在150kb以內\n您上傳的圖片檔案大小為：154.59kb`,
    },
    {
        column1: "未偵測到符合之版位！",
        column2: "24-0515-百虹歡璽城 (1).jpg",
        column3: "您上傳的圖片尺寸為：625x521px",
    },
];

async function downloadExcel(dataArray) {
    try {
        const response = await fetch("/export-data", {
            method: "POST",
            headers: {
                "X-CSRF-TOKEN": document
                    .querySelector('meta[name="csrf-token"]')
                    .getAttribute("content"),
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: dataArray,
            }),
        });
        if (!response.ok) {
            throw new Error(
                "Network response was not ok " + response.statusText
            );
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${getCurrentDateTime()}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error:", error);
    }
}

// 調用下載函數
downloadAllErrorExcelBtn.addEventListener("click", () =>
    downloadExcel(sendExcelDataToBack())
);

const sendExcelDataToBack = () => {
    // 新增排序來符合前端版面
    let items = Array.from(
        document.querySelectorAll('.show-list-item[data-qualified="false"]')
    );
    items.sort((a, b) => {
        const orderMap = {
            "zip-false": -4,
            "multiple-matches-gif": -3,
            "multiple-matches": -2,
            gif: -1,
            "no-match": 1,
        };

        const aOrder =
            orderMap[
                `${a.getAttribute("data-false-type")}-${a.getAttribute(
                    "data-type"
                )}`
            ] ||
            orderMap[a.getAttribute("data-false-type")] ||
            orderMap[a.getAttribute("data-type")] ||
            0;

        const bOrder =
            orderMap[
                `${b.getAttribute("data-false-type")}-${b.getAttribute(
                    "data-type"
                )}`
            ] ||
            orderMap[b.getAttribute("data-false-type")] ||
            orderMap[b.getAttribute("data-type")] ||
            0;

        return aOrder - bOrder;
    });

    let datas = [];

    items.forEach((element) => {
        let wrongBoard =
            element.querySelector(".show-list-info p").textContent || "";
        let errorMsg =
            element.querySelector(".show-list-false-info p").textContent || "";
        let baseName =
            element
                .querySelector(".show-list-img-info p")
                .textContent.replace(/^您上傳之圖片為：/, "") || "";

        let baseSize =
            element.querySelector(".original-size-info").textContent || "";
        let baseDimensions =
            element.querySelector(".original-dimensions-info").textContent ||
            "";
        let data = {
            column1: `${wrongBoard}`,
            column2: `${baseName}`,
            column3: `${baseSize}`,
            column4: `${baseDimensions}`,
            column5: `${errorMsg}`,
        };
        datas.push(data);
    });

    return datas;
};

function getCurrentDateTime() {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(now.getDate()).padStart(2, "0");
    const hour = String(now.getHours()).padStart(2, "0"); // 24-hour format

    const formattedDateTime = `${year}-${month}-${day}-${hour}`;

    return formattedDateTime;
}

console.log(getCurrentDateTime());
